/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_AlertInputs */

const fr_season_alert = /** @type {((inputs: Season_AlertInputs) => LocalizedString) & { parts: (inputs: Season_AlertInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Season_AlertInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Le mode Vacances est actif. La Saison définie ici est ignorée et l'automate est en mode Arrêt`)
		}),
		{
			parts: /** @type {(inputs: Season_AlertInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Le mode " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Vacances" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: " est actif. La Saison définie ici est ignorée et l'automate est en mode Arrêt" }])
			})
		}
	)
);

const en_season_alert = /** @type {((inputs: Season_AlertInputs) => LocalizedString) & { parts: (inputs: Season_AlertInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Season_AlertInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`The Holidays mode is active. The Season set here is ignored and the controller is in Stop mode`)
		}),
		{
			parts: /** @type {(inputs: Season_AlertInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "The " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Holidays" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: " mode is active. The Season set here is ignored and the controller is in Stop mode" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "The Holidays mode is active. The Season set here is ignored and the controller is in Stop mode" |
*
* @param {Season_AlertInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_alert = /** @type {((inputs?: Season_AlertInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Season_AlertInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Season_AlertInputs, { locale?: "fr" | "en" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Season_AlertInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_season_alert(inputs)
			return fr_season_alert(inputs)
		}),
		{
			parts: /** @type {(inputs?: Season_AlertInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Season_AlertInputs) => import('../runtime.js').MessagePart[] }} */ (en_season_alert).parts?.(inputs) ?? [{ type: "text", value: en_season_alert(inputs) }]
				return /** @type {{ parts?: (inputs: Season_AlertInputs) => import('../runtime.js').MessagePart[] }} */ (fr_season_alert).parts?.(inputs) ?? [{ type: "text", value: fr_season_alert(inputs) }]
			})
		}
	)
);